var _jsxFileName = "/repo/packages/ippm/src/components/FeatureSectionHeader/index.js",
  _this = this;
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Typography } from '@sm/wds-react';
import './feature-section-header.scss';
var FeatureSectionHeader = function FeatureSectionHeader(_ref) {
  var children = _ref.children,
    className = _ref.className,
    customHeader = _ref.customHeader;
  var cls = classNames('wds-type--left', 'wds-m-l-4', customHeader ? 'wds-m-b-1' : 'wds-m-b-3', 'wds-p-b-1', 'feature-section__header', className);
  return /*#__PURE__*/React.createElement(Typography, {
    component: "h3",
    className: cls,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 5
    }
  }, children);
};
FeatureSectionHeader.defaultProps = {
  className: '',
  customHeader: false
};
FeatureSectionHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  customHeader: PropTypes.bool
};
export default FeatureSectionHeader;